import { useState, useEffect } from "react";
//
import Context from "./Context";
//
import authService from "./index";

export default function AuthProvider(attr) {
  const [value, setValue] = useState(authService.state);

  useEffect(() => {
    authService.subscribe(setValue);
  }, []);

  const props = {
    value,
    ...attr,
  };

  return <Context.Provider {...props} />;
}
